import { render, staticRenderFns } from "./RatingInput.vue?vue&type=template&id=47b79e14"
import script from "./RatingInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./RatingInput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RatingInput.vue?vue&type=style&index=0&id=47b79e14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports